import { useCallback, useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import { Loader } from "semantic-ui-react";
import { IParameter } from "../../models/parameter";
import { getInProgressParameters } from "../../services/parametersService";
import { NclpParameterCard } from "../../containers/ParameterCard/NclpParameterCard";
import { toast } from "../..";
import { responsiveCarousel } from "../../helpers/commonHelper";

export const ParametersCarousel = () => {
    const [inProgressParameters, setInProgressParameters] = useState<IParameter[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchParameters = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getInProgressParameters();
            setInProgressParameters(res);
        } catch {
            toast("Error fetching parameters", false, 1000);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchParameters();
    }, [fetchParameters]);

    return (
        <>
            <Loader active={loading} inline="centered" />
            <Carousel responsive={responsiveCarousel}>
                {inProgressParameters.map(x => (
                    <div className="action-bar-container" key={x.guid}>
                        <NclpParameterCard
                            parameter={x}
                            isDevelopment
                            refreshTrigger={() => fetchParameters()}
                        />
                    </div>
                ))}
            </Carousel>
            {inProgressParameters.length === 0 && !loading && <b>No parameters in progress.</b>}
        </>
    );
};
